<template>
  <div style="height: 100%">
    <header>
      <div class="header-left"></div>
      <div class="header-right">
        <div class="user-info">
          <el-dropdown>
            <div class="user-name">
              你好，{{userName}}
              <i class="el-icon-arrow-down icon user-icon"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <div class="more-info">
                <div class="item">
                  <i class="user-img"></i>
                  <p class="name">{{ userName }}</p>
                </div>
                <div class="item">
                  <img class="icon" style="width: 9px;padding-left: 3px;padding-right: 3px"
                       src="../assets/images/icon_mobile.png"/>
                  <p class="p">手机号码：{{mobile}}</p>
                </div>
                <div class="item">
                  <img class="icon" style="width: 13px;height: 12px;padding-left: 1px;padding-top: 1px"
                       src="../assets/images/icon_sid.png"/>
                  <p class="p">销售SID：{{sid}}</p>
                </div>
                <div class="item">
                  <img class="icon" src="../assets/images/icon_type.png"/>
                  <p class="p">用户类型：{{ getUserType(userType)}}</p>
                </div>
                <div class="item">
                  <img class="icon" src="../assets/images/icon_job.png"/>
                  <p class="p">岗位：{{jobTitle }}</p>
                </div>
                <div class="item">
                  <img class="icon" src="../assets/images/icon_dep.png"/>
                  <p class="p">所属架构/酒店：{{ deptName}}</p>
                </div>
                <input type="button" class="button-long" @click="logout" value="退出登录">
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </header>
    <div class="main-father">
      <main>
        <div class="main-content" :style="style_main">
          <div class="square"></div>
          <div class="content-head"></div>
          <div class="main-body" :style="style_body">
            <div style="height: 4px"></div>
            <div class="content-logo">
              <div class="head-logo"></div>
            </div>
            <div class="content-body">
              <div class="card" v-for="(item,index) in modules"
                   @click="goTo(item.pageUrl,item.nameEn, item.name)">
                <img :src="item.icon" style="width:100%;height: 100%">
                <div class="card-name">{{item.name}}</div>
                <div class="card-detail">{{item.description}}</div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
  import * as Cookies from "tiny-cookie";
  import {getLoginInfo, getLoginMenus, logout, getUserTags} from "../assets/js/request";
  import {appId, auth, logoutUrl} from "../assets/js/env";
  import wehotelSensors from '../assets/js/wehotel.sensors.sdk';

  export default {
    data() {
      return {
        userName: '',
        mobile: '',
        sid: '',
        userType: '',
        jobTitle: '',
        deptName: '',
        modules: [],
        style_main: '',
        style_body: ''
      };
    },
    mounted() {
      if (Cookies.getCookie('token')) {
        this.getLoginInfo();
        this.getLoginMenus();
      } else {
        window.location.href = logoutUrl;
      }

      // Cookies.setCookie('token', 'LONGdb6a08f0bd33456bbd69dcf4028a7b98');
      // this.getLoginInfo();
      // this.getLoginMenus();
    },
    methods: {
      getUserType(index) {
        const data = {
          1: "分店员工",
          3: "集团用户",
          4: "投资人",
          7: "高校代理",
          8: "企业拓展代理",
          9: "铂物馆供应商",
          10: "旅游分销商"
        };
        return data[index] || "";
      },
      getLoginInfo() {
        let params = {};
        params.appId = appId;
        params.token = Cookies.getCookie('token');
        getLoginInfo(params).then(res => {
          let result = res.result;
          this.userName = result.userName;
          this.mobile = result.mobile;
          this.sid = result.sid;
          this.userType = result.userType;
          let userStores = result.userStores;
          this.jobTitle = userStores[0].jobTitle;
          this.deptName = userStores[0].deptName;
          wehotelSensors.$emit('login', result.userId); // 登入神策
        }).catch(err => {
          console.log(err)
        });
      },
      getLoginMenus() {
        let params = {};
        params.appId = appId;
        params.token = Cookies.getCookie('token');
        getLoginMenus(params).then(res => {
          let code = res.data.messageCode;
          if (code == '200') {
            this.modules = res.data.data.subs;
            if (this.modules.length > 6) {
              this.style_main = {height: '715px'};
              this.style_body = {height: '627.4px'};
            }
          } else if (code == '300') {
            window.location.href = logoutUrl
          } else {
            this.$message.error(res.data.message);
          }
        }).catch(err => {
          console.log(err)
        });
      },
      logout() {
        let params = {};
        params.appId = appId;
        params.token = Cookies.getCookie('token');
        logout(params).then(res => {
          window.location.href = logoutUrl
        }).catch(err => {
          console.log(err)
        })
      },
      goTo(url, name, nameCn) {
        if (url) {
          wehotelSensors.$emit('track', 'whgzt_menu_click', {
            positionName_var:  nameCn,
            pageName: 'wehotel工作台',
          });
          if (name === 'companyOfficialFrontendAdmin') {
            window.open(url + '&token=' + Cookies.getCookie('token'));
          } else {
            window.open(url);
          }
        } else {
          this.$message('请先配置跳转地址！');
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .more-info {
    padding: 0 16px 6px;
    width: 272px;
    background-color: #FFFFFF;

    .item {
      display: flex;
      align-items: baseline;
      padding: 10px 0;
      color: #2b3249;
      font-size: 14px;

      &:first-child {
        padding: 10px 0;
        align-items: center;
      }

      .icon {
        width: 15px;
        height: 15px;
        margin-right: 10px;
        padding: 0;
        position: relative;
        top: 2px;
      }

      .user-img {
        width: 42px;
        height: 42px;
        background-image: url("../assets/images/icon_user.png");
        background-size: 100%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        box-shadow: 0 6px 21px 0 #e5e5e5;
        display: inline-block;
        vertical-align: middle;
        border-radius: 100%;
      }

      .name {
        font-size: 16px;
        padding-left: 16px;
        font-weight: bold;
      }
    }

    .button-long {
      width: 100%;
      height: 40px;
      background: #0750DD;
      border-radius: 2px;
      cursor: pointer;
      font-weight: 400;
      color: #FFFFFF;
      border: none;
      margin-top: 15px;
      font-size: 14px;
      letter-spacing: 1px;
    }
  }

  header {
    width: 100%;
    display: flex;
    background: #FFFFFF;

    .header-left {
      width: calc(100% - 157px);
    }

    .header-right {
      width: 157px;
      height: 49px;

      .user-info {
        float: right;
        margin-top: 15px;
        cursor: pointer;

        .user-name {
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #2B3249;
          line-height: 20px;
          margin-bottom: 14px;
          margin-right: 16px;

          .user-icon {
            width: 16px;
            height: 16px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .main-father {
    width: 100%;
    height: calc(100vh - 49px);
    /*background-image: url("../assets/images/bg.png");*/
    background-color: #F4FCFF;
    overflow: auto;
    position: absolute;

    main {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;

      .main-content {
        width: 1035px;
        height: 541px;
        background: #F4FCFF;
        overflow-y: auto;
        overflow-x: hidden;
        position: absolute;
        padding-top: 10px;
        top: 19px;

        .square {
          width: 165px;
          height: 166px;
          background-image: url("../assets/images/square.png");
          background-size: 100%;
          position: absolute;
          right: 36px;
          animation: move 5s infinite;
          -webkit-animation: move 5s infinite;
        }

        @-webkit-keyframes move {
          0% {
            transform: translate(0px, 0);
          }
          50% {
            transform: translate(0px, -0.5vw);
          }
          100% {
            transform: translate(0px, 0);
          }
        }

        .content-head {
          height: 67px;
          background-color: #F4FCFF;
        }

        .main-body {
          width: 1035px;
          height: 454px;
          background: #FFFFFF;
          box-shadow: 0px 16px 24px 0px rgba(63, 107, 255, 0.04);
          border-radius: 8px;

          .content-logo {
            width: 1027px;
            height: 72px;
            background-image: url("../assets/images/rectangle.png");
            background-size: 100%;
            margin: 0 4px 0 4px;
            overflow: hidden;

            .head-logo {
              width: 225px;
              height: 30px;
              background-image: url("../assets/images/head_title.png");
              background-size: 100%;
              margin: 23px 0 19px 26px;
            }
          }

          .content-body {
            display: flex;
            flex-flow: row wrap;
            margin: 24px 8px 8px 24px;

            .card {
              position: relative;
              width: 318px;
              height: 157px;
              margin: 0 16px 16px 0;
              cursor: pointer;
              background-size: 100%;
              border-radius: 8px;
              transition: all 0.7s;

              &:hover {
                background: linear-gradient(62deg, #DFF6FF 0%, #DAEDFF 100%);
                box-shadow: 0px 4px 12px 0px rgba(214, 231, 255, 0.37);
                border-radius: 8px;
                transform: scale(1.02);

                .card-name {
                  transform: translate3d(0, 0, 0);
                }

                .card-detail {
                  transform: translate3d(0, 0, 0);
                }
              }

              .card-name {
                position: absolute;
                top: 26px;
                left: 27px;
                height: 22px;
                font-size: 16px;
                font-weight: 600;
                color: #2B3249;
                line-height: 22px;
              }

              .card-detail {
                position: absolute;
                top: 56px;
                left: 26px;
                width: 280px;
                height: 20px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(43, 50, 73, 0.6);
                line-height: 20px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue